/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SequenceRules } from './sequenceRules';
import type { SequenceSchedule } from './sequenceSchedule';

/**
 * Partial update for ``PATCH /api/jobs/{job_id}/sequences/{id}``.
 *
 * All fields optional; ``model_validator`` rejects empty payloads
 * so the service can rely on at least one field being present.
 */
export interface SequenceUpdate {
  name?: string | null;
  description?: string | null;
  sender_user_id?: string | null;
  mailbox_id?: string | null;
  schedule?: SequenceSchedule | null;
  rules?: SequenceRules | null;
}
